import { Component } from '@angular/core';

@Component({
    selector: 'app-default-header',
    templateUrl: './default-header.component.html',
    styleUrls: ['./default-header.component.scss'],
    standalone: false
})
export class DefaultHeaderComponent {}
